<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ title }} Invoice
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6">
            <v-menu
              v-model="showStartDatePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.from_date"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="Start Date*"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.from_date"
                :min="minDate"
                @input="showStartDatePicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-menu
              v-model="showEndDatePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.to_date"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="End Date*"
                  outlined
                  dense
                  hide-details="auto"
                  :disabled="!form.from_date"
                  :rules="[rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.to_date"
                :min="form.from_date"
                @input="trackDateChange(), (showEndDatePicker = false)"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save"> Save</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    title: {
      type: String,
      default: () => "Exam",
    },
  },
  data() {
    return {
      rules,
      form: {},
      showStartDatePicker: false,
      showEndDatePicker: false,
    };
  },
  computed: {
    minDate() {
      return this.currentDate(new Date());
    },
    formattedFromDate() {
      if (!this.form.from_date) return "";
      const [year, month, day] = this.form.from_date.split("-");
      return `${day}-${month}-${year}`;
    },
    formattedEndDate() {
      if (!this.form.to_date) return "";
      const [year, month, day] = this.form.to_date.split("-");
      return `${day}-${month}-${year}`;
    },
  },
  created() {
    this.form = { ...this.studentExternalMark };
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.$emit("save", this.form);
    },
    currentDate(date) {
      const d = new Date(date);
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    trackDateChange() {
      if (this.form.from_date > this.form.to_date) {
        this.form.to_date = "";
      }
    },
  },
};
</script>

<style scoped></style>
